import * as sterlingparker from './Matches.styles.sterlingparker';
import * as goldenrush from './Matches.styles.goldenrush';
import * as betroyale from './Matches.styles.betroyale';
import * as puntcity from './Matches.styles.puntcity';
import * as betgalaxy from './Matches.styles.betgalaxy';
import * as juicybet from './Matches.styles.juicybet';
import * as questbet from './Matches.styles.questbet';
import * as wellbet from './Matches.styles.wellbet';
import * as sugarcastle from './Matches.styles.sugarcastle';
import * as oldgill from './Matches.styles.oldgill';
import * as buffalobet from './Matches.styles.buffalobet';
import * as titanbet from './Matches.styles.titanbet';
import * as gigabet from './Matches.styles.gigabet';
import * as slambet from './Matches.styles.slambet';
import * as betstride from './Matches.styles.betstride';
import * as templebet from './Matches.styles.templebet';
import * as goldenbet888 from './Matches.styles.goldenbet888';
import * as hyperbet from './Matches.styles.hyperbet';
import * as bet777 from './Matches.styles.bet777';
import * as chromabet from './Matches.styles.chromabet';
import * as bet575 from './Matches.styles.bet575';
import * as betblast from './Matches.styles.betblast';
import * as pyramidbet from './Matches.styles.pyramidbet';
import * as magnumbet from './Matches.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  goldenrush,
  betroyale,
  puntcity,
  betgalaxy,
  juicybet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
